const Menu = [
    {
        title: "Dashboard",
        group: "apps",
        icon: "home",
        name: "Dashboard",
        route: "dashboard",
        permission: ["admin"],
    },
    {
        title: "Project",
        icon: "mdi-application",    
        route:"project",        
        permission: ["admin"],
    },
    {
        title: "Template",
        icon: "mdi-message",
        route:"template",                
        permission: ["admin"],
    },
    {
        title: "Segmentation",
        icon: "mdi-message",
        route:"segmentation",                
        permission: ["admin"],
    },
    {
        title: "Subscriber",
        icon: "people",
        route:"subscriber",     
        permission: ["admin"],
    },
    //  {
    //     title: "Subscriber",
    //     group: "banner",
    //     icon: "people",
    //     items: [
    //         { name: "banner_list", title: "banner_list", route: "banner" },
    //         { name: "banner_new", title: "banner_new", route: "banner_new" },
    //     ],
    //     permission: ["admin"],
    // },
    {
        title: "Segmentation",
        icon: "mdi-chart-pie",        
        route:"merchant",
        permission: ["admin"]
    },
    {
        title: "API",
        icon: "mdi-api",        
        route:"member",
        permission: ["admin"]

    },
];

module.exports = {
    Menu
};
